export const mutations = {
  // 设置用户信息
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo
  },
  // 设置token
  SET_TOKEN (state, token) {
    state.token = token
  },
  // 设置tabsList
  SET_TABS_LIST (state, tabsList) {
    state.tabsList = tabsList
  },
  // 设置底部table首页路由最后离开时滚动位置
  SET_TABS_LEAVE_SITE (state, TabsLeaveSite) {
    state.TabsLeaveSite = TabsLeaveSite
  },
}
